import { render } from "./GenericSelect.vue?vue&type=template&id=5183fe25"
import script from "./GenericSelect.vue?vue&type=script&lang=js"
export * from "./GenericSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__